export default __webpack_public_path__ + "static/media/canadaFlagButton.b2c0b5ee.png";